import axios from "axios"
const server_api_url = (window.__CONFIG__ && window.__CONFIG__.SERVER_API_URL && window.__CONFIG__.SERVER_API_URL !== '${SERVER_API_URL}') ?
  window.__CONFIG__.SERVER_API_URL : import.meta.env.VITE_SERVER_API_URL

export function login(data, config) {
  let url = `${server_api_url}api/auth/login`
  return axios.post(url, data, config)
}
export function loadProfile(config) {
  let url = `${server_api_url}api/users/get-current-user`
  return axios.get(url, config)
}

export function saveProfile(data, config) {
  data.phoneNumber = data.phoneNumber.replace(/\D/g, '')
  let url = `${server_api_url}api/user-self`
  return axios.put(url, data, config)
}
export function changePassword(data, config) {
  let url = `${server_api_url}api/user-self/update-password`
  return axios.put(url, data, config)
}


export default {
  login,
  loadProfile,
  saveProfile,
  changePassword,
}
